import "./ComputedField.scss";

interface ComputedFieldProps {
  label: string;
  value: string;
  inline?: boolean;
  suffix?: string;
}

const ComputedField = ({
  label,
  value,
  inline,
  suffix,
}: ComputedFieldProps) => {
  return (
    <div className={`computed-field${inline ? " computed-field--inline" : ""}`}>
      <label className="computed-field__label">{label}</label>
      <div className="computed-field__value">
        <span className="computed-field__value-text">{value}</span>
        {suffix && <span className="computed-field__suffix">{suffix}</span>}
      </div>
    </div>
  );
};

export default ComputedField;
